module.exports = __webpack_public_path__ + "img/plus_icon.5adec396.svg";